import * as d3 from 'd3';
import line from './line';

const area = {
  id: 'area',
  label: 'Area',
  getYExtent: line.getYExtent,
  draw({ group, data, xScale, yScale, theme, defs }) {
    defs.selectAll('#area-gradient').remove();
    const gradient = defs
      .append('linearGradient')
      .attr('id', 'area-gradient')
      .attr('x1', '0%')
      .attr('y1', '0%')
      .attr('x2', '0%')
      .attr('y2', '100%');
    gradient.append('stop').attr('offset', '0%').attr('stop-color', theme.primaryLine).attr('stop-opacity', 0.32);
    gradient.append('stop').attr('offset', '100%').attr('stop-color', theme.primaryLine).attr('stop-opacity', 0);

    const areaGen = d3
      .area()
      .x((d) => xScale(d.date))
      .y0(yScale.range()[0])
      .y1((d) => yScale(d.close))
      .curve(d3.curveMonotoneX);

    group
      .selectAll('.mark-area')
      .data([data])
      .join('path')
      .attr('class', 'mark-area')
      .attr('fill', 'url(#area-gradient)')
      .attr('d', areaGen);

    line.draw({ group, data, xScale, yScale, theme });
  },
  tooltipFields: line.tooltipFields,
};

export default area;
